import { defineStore } from 'pinia'
import { HomeBannerListInfo } from '@/api/banner/bannerType'

// 轮播图
export const useHomeBannerStore = defineStore(
  'homeBanner',
  () => {
    const homeBannerDetail = ref<HomeBannerListInfo>()

    const editingHomeBannerDetail = ref<HomeBannerListInfo>()

    const isEdit = ref(false)

    return {
      homeBannerDetail,
      editingHomeBannerDetail,
      isEdit,
    }
  },
)
